var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/product-tray/grid.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-column o-extra-small--12 o-slider-product-tray__wrapper s-product-tray-grid\" data-qa-product-tray-grid>\n\n    <div class=\"o-slider-product-tray o-slider-product-tray--product-image c-product-tray__grid-inner u-centered-content\">\n\n        ";
var t_1;
t_1 = 4;
frame.set("limit", t_1, true);
if(frame.topLevel) {
context.setVariable("limit", t_1);
}
if(frame.topLevel) {
context.addExport("limit", t_1);
}
output += "\n\n        ";
frame = frame.push();
var t_4 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tray")),"records");
if(t_4) {var t_3 = t_4.length;
for(var t_2=0; t_2 < t_4.length; t_2++) {
var t_5 = t_4[t_2];
frame.set("record", t_5);
frame.set("loop.index", t_2 + 1);
frame.set("loop.index0", t_2);
frame.set("loop.revindex", t_3 - t_2);
frame.set("loop.revindex0", t_3 - t_2 - 1);
frame.set("loop.first", t_2 === 0);
frame.set("loop.last", t_2 === t_3 - 1);
frame.set("loop.length", t_3);
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") <= 5) {
output += "\n\n                ";
var t_6;
t_6 = "";
frame.set("utilityClasses", t_6, true);
if(frame.topLevel) {
context.setVariable("utilityClasses", t_6);
}
if(frame.topLevel) {
context.addExport("utilityClasses", t_6);
}
output += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 3) {
var t_7;
t_7 = "u-extra-small--hide u-medium--show";
frame.set("utilityClasses", t_7, true);
if(frame.topLevel) {
context.setVariable("utilityClasses", t_7);
}
if(frame.topLevel) {
context.addExport("utilityClasses", t_7);
}
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 4 || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 5) {
output += "\n                    ";
var t_8;
t_8 = "u-extra-small--hide u-large--show";
frame.set("utilityClasses", t_8, true);
if(frame.topLevel) {
context.setVariable("utilityClasses", t_8);
}
if(frame.topLevel) {
context.addExport("utilityClasses", t_8);
}
;
}
;
}
output += "\n\n                <div class=\"o-column o-extra-small--6 o-medium--4 ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "utilityClasses"), env.opts.autoescape);
output += " u-no-gutters c-product-tray__tile\" data-qa-product-tray-slide>";
var t_9;
t_9 = (lineno = 20, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_5,"allMeta.tile.product.productSlug"]));
frame.set("productSlug", t_9, true);
if(frame.topLevel) {
context.setVariable("productSlug", t_9);
}
if(frame.topLevel) {
context.addExport("productSlug", t_9);
}
var t_10;
t_10 = (lineno = 21, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","product tray|" + "" + runtime.contextOrFrameLookup(context, frame, "eventActionName") + "" + " click",runtime.contextOrFrameLookup(context, frame, "productSlug")]));
frame.set("analytics", t_10, true);
if(frame.topLevel) {
context.setVariable("analytics", t_10);
}
if(frame.topLevel) {
context.addExport("analytics", t_10);
}
var t_11;
t_11 = (lineno = 22, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","product tray|" + "" + runtime.contextOrFrameLookup(context, frame, "eventActionName") + "" + " quickshop",runtime.contextOrFrameLookup(context, frame, "productSlug")]));
frame.set("quickShopAnalytics", t_11, true);
if(frame.topLevel) {
context.setVariable("quickShopAnalytics", t_11);
}
if(frame.topLevel) {
context.addExport("quickShopAnalytics", t_11);
}
output += runtime.suppressValue((lineno = 24, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayProductTile"), "displayProductTile", context, [runtime.memberLookup((runtime.memberLookup((t_5),"allMeta")),"tile"),runtime.makeKeywordArgs({"tileTemplate": runtime.contextOrFrameLookup(context, frame, "tileType"),"productIndex": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"analytics": runtime.contextOrFrameLookup(context, frame, "analytics"),"analyticsQuickShop": runtime.contextOrFrameLookup(context, frame, "quickShopAnalytics"),"displayFavorites": runtime.contextOrFrameLookup(context, frame, "displayFavorites"),"lazy": runtime.contextOrFrameLookup(context, frame, "isLazy")})])), env.opts.autoescape);
output += "\n\n                </div>\n\n            ";
;
}
;
}
}
frame = frame.pop();
output += "</div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/product-tray/grid.j2"] , dependencies)